module.exports = __webpack_public_path__ + "static/media/big.7fb0561f.png";